import { DataTable, Flex } from '@raystack/apsara';
import _ from 'lodash';

import styles from '@src/components/Custom/ModelCommonComponents/styles.module.css';

const AreaPercentageTable = ({ data }) => {
  if (!data.length > 0) return null;
  const columns = [
    {
      header: () => null,
      accessorKey: 'color',
      cell: ({ row: { original: item } }) => (
        <div
          className={styles.filledBox}
          style={{
            backgroundColor: `${item.color}`
          }}
        />
      )
    },
    {
      header: 'Class',
      accessorKey: 'class'
    },
    {
      header: 'Change',
      accessorKey: 'differenceInKm',
      cell: ({ row: { original: item } }) => (
        <Flex>
          {item.differenceIcon}
          {Math.abs(item.differenceInKm)} km² ({Math.abs(item.total)}
          %)
        </Flex>
      )
    },
    {
      header: 'Reference',
      accessorKey: 'refArea',
      cell: ({ row: { original: item } }) => (
        <>
          {item.refArea}km<sup>2</sup> ({item.refPercentage}%)
        </>
      )
    },
    {
      id: 'comparison',
      header: 'Comparison',
      accessorKey: 'compArea',
      cell: ({ row: { original: item } }) => (
        <>
          {item.compArea}km<sup>2</sup> ({item.compPercentage}%)
        </>
      )
    }
  ];

  if (_.has(data[0], 'range')) {
    columns.splice(2, 0, {
      id: 'range',
      header: 'Range',
      cell: ({ row: { original: item } }) => item.range || '-'
    });
  }

  return (
    <div className={styles.tableWrapper}>
      <DataTable
        data={data}
        columns={columns}
        defaultSort={{ name: 'class', order: 'asc' }}
      >
        <DataTable.Content />
      </DataTable>
    </div>
  );
};

export default AreaPercentageTable;
